import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const PUBLIC_ACCESS_TOKEN_KEY = "public_access_token";

const PublicAccessContext = createContext(null);

export const PublicAccessProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(() =>
    sessionStorage.getItem(PUBLIC_ACCESS_TOKEN_KEY)
  );

  const saveToken = useCallback((token) => {
    sessionStorage.setItem(PUBLIC_ACCESS_TOKEN_KEY, token);
    setAccessToken(token);
  }, []);

  const clearToken = useCallback(() => {
    sessionStorage.removeItem(PUBLIC_ACCESS_TOKEN_KEY);
    setAccessToken(null);
  }, []);

  // Listen for token-expired events dispatched by _BaseAPIService
  useEffect(() => {
    const handleExpired = () => {
      clearToken();
    };
    window.addEventListener("publicAccessTokenExpired", handleExpired);
    return () => window.removeEventListener("publicAccessTokenExpired", handleExpired);
  }, [clearToken]);

  return (
    <PublicAccessContext.Provider value={{ accessToken, saveToken, clearToken }}>
      {children}
    </PublicAccessContext.Provider>
  );
};

export const usePublicAccess = () => {
  const ctx = useContext(PublicAccessContext);
  if (!ctx) {
    throw new Error("usePublicAccess must be used within a PublicAccessProvider");
  }
  return ctx;
};

export default PublicAccessContext;
